/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventLogEntryList } from '../../models/event-log-entry-list';
import { EventLogSearchBody } from '../../models/event-log-search-body';
import { EventLogSortFieldName } from '../../models/event-log-sort-field-name';
import { SortDirection } from '../../models/sort-direction';

export interface GetEventsLog$Json$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * DATE : the date
 *   * TAG : the tag name
 *   * DESCRIPTION : the tag description
 *   * VALUE : the value
 */
  sortFieldName?: EventLogSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search events log
     */
    body?: EventLogSearchBody
}

export function getEventsLog$Json(http: HttpClient, rootUrl: string, params: GetEventsLog$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogEntryList>> {
  const rb = new RequestBuilder(rootUrl, getEventsLog$Json.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EventLogEntryList>;
    })
  );
}

getEventsLog$Json.PATH = '/stations/{uid}/eventslog/search';
